import request from '@/utils/request'

export * from './signstore'

/**
 * H5 外链静默登录：外链 query 仍为纯 uid；body 传 uid + activityCode（来自活动入口），服务端拼接入库。
 */
export function h5ThirdPartSilentLogin(body) {
  return request.post('/wxapp/h5ThirdPartSilent', body)
}
